import axios from 'axios'

class QuestionnaireA3CloudService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }
    /**
      * @author Edgar Escobedo
      * @description Get all questionnaires by clientId
      * @param {string} clientId
      * @param {string} token
      * @memberof QuestionnaireA3CloudService
      */
    async getAllQuesttionnairesByClientIdFromA3Cloud(clientId, token) {
        let response = await axios.get(`${this.apiUrl}/questionnaires?clientId=${clientId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data.data;
    }

    /**
      * @author Edgar Escobedo
      * @description Get a questionnaire by id
      * @param {string} id
      * @param {string} token
      * @memberof QuestionnaireA3CloudService
      */
     async getQuestionnaireById(id, token) {
        let response = await axios.get(`${this.apiUrl}/questionnaire-by-id?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data.data;
     }

    /**
    * @author Edgar Escobedo
    * @description Get all questionnaires for new contract
    * @param {string} token
    * @memberof QuestionnaireA3CloudService
    */
    async getQuestionnairesNewContract(token) {
        let response = await axios.get(`${this.apiUrl}/questionnaires-new-contract`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data.data;
    }
}

export { QuestionnaireA3CloudService as default };
